/* @flow */
let nextValue = 0;

export default function enumerate(keys: Array<string>): Object {
  const obj = {};

  keys.forEach(key => {
    obj[key] = nextValue;
    nextValue++;
  });

  Object.freeze(obj);
  return obj;
}



// WEBPACK FOOTER //
// ./src/lib/enumerate.js